export class Nivel {
  CodigoNivel: string;
  DescricaoNivel: string;
  ValorNivel: string;
}
